import React from 'react';
import { Navigate } from 'react-router-dom';
import { routes } from '../routes';

interface RoleRouteProps {
  allow: boolean;
  children: React.ReactNode;
  redirectTo?: string;
}

/** Redirects when the current user fails a permission check (defense in depth with API). */
export const RoleRoute: React.FC<RoleRouteProps> = ({
  allow,
  children,
  redirectTo = routes.dashboard,
}) => {
  if (!allow) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};
